<script setup lang="ts">
import { useGoTo } from 'vuetify'
import type { PaginationProps } from '@/types/appTypes'

const props = withDefaults(defineProps<PaginationProps>(), {
  page: 1,
  length: 1,
})

const route = useRoute()
const goTo = useGoTo()

const modelPageNo = ref(props.page)

const onChangePage = (val) => {
  const query = { ...route.query }
  if (val > 0) {
    query.page = val
  } else {
    delete query.page
  }
  goTo('body', { duration: 300 })

  navigateTo({
    path: route.path,
    query,
  })
}
</script>

<template>
  <div class="c-pagination">
    <v-pagination
      v-model="modelPageNo"
      v-bind:length="length"
      prev-icon="mdi-chevron-left"
      next-icon="mdi-chevron-right"
      density="comfortable"
      v-on:update:model-value="onChangePage"
    />
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive" as responsive;

.c-pagination {
  :deep(.v-pagination__item) {
    min-width: 40px !important;
    height: 40px;
    margin-right: 5px;
    margin-left: 5px;
    border: 1px solid var(--g_color_border_gray);
    border-radius: 0;
    box-shadow: none;
    font-size: 14px;
    letter-spacing: -1px;
    white-space: nowrap;

    &.v-pagination__item--is-active {
      border: 1px solid var(--color_primary) !important;
      background-color: var(--g_color_background_white) !important;
      color: var(--color_primary) !important;

      .v-btn__overlay {
        background-color: var(--g_color_background_white) !important;
      }
    }

    &:hover {
      opacity: 0.7;
    }
  }

  :deep(.v-pagination__navigation) {
    box-shadow: none;

    &:hover {
      opacity: 0.7;
    }
  }
}
</style>
